import React from 'react';
import { useGlassEffect, useServiceTabAnimation } from '../../hooks/useAnimations';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  isTab?: boolean;
}

export const GlassCard: React.FC<GlassCardProps> = ({ 
  children,
  className = '',
  isTab = false
}) => {
  const { glassClasses } = useGlassEffect();
  const { tabClasses } = useServiceTabAnimation();

  const combinedClasses = isTab 
    ? `${glassClasses} ${tabClasses} ${className}`
    : `${glassClasses} ${className}`;

  return (
    <div className={combinedClasses}>
      {children}
    </div>
  );
};
